module.exports = {
  BEFORE_DISCOUNT: 'before_discount',
  AFTER_DISCOUNT: 'after_discount'
}
